import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { CircularProgress } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { ClassKeyOfStyles, ClassNameMap } from '@material-ui/styles/withStyles';
import * as authActions from '../../store/actions/auth_actions';
import { IState } from '../../store/reducers';
import style from './styles';

// import useRedirect from './RedirectHook';

interface IProps {
  classes: ClassNameMap<ClassKeyOfStyles<string>>;
  postOAuthTokenRequest: (loginRequest: any) => any;
  redirectPath: string;
  vendAuthenticated: boolean;
  token: string;
  location: {
    search: string;
    pathname: string;
  };
}

const VendOAuthHandler: React.FC<IProps> = props => {
  const { classes, location, vendAuthenticated, postOAuthTokenRequest } = props;

  const [doRedirect, setDoRedirect] = useState<boolean>(false);

  useEffect(() => {
    if (vendAuthenticated) {
      setDoRedirect(true);
    }
  }, [vendAuthenticated]);

  // didMount fetch data
  useEffect(() => {
    if (location) {
      if (vendAuthenticated) {
        setDoRedirect(true);
      }

      const params = new URLSearchParams(location.search);

      if (params.get('code')) {
        postOAuthTokenRequest({
          system: 'vend',
          code: params.get('code'),
          domain_prefix: params.get('domain_prefix'),
          state: params.get('state'),
        });
      }
    }
  }, []);

  return (
    <div className={classes.container}>
      {doRedirect && <Redirect to={props.redirectPath ? props.redirectPath : '/admin/vend-app'} />}
      <CircularProgress size={100} />
      {/*<button onClick={() => setRedirect(true)}>Redirect</button>*/}
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  vendAuthenticated: state.vend.authenticated,
  redirectPath: state.auth.redirectPath,
});

const mapDispatchToProps = {
  postOAuthTokenRequest: authActions.postOAuthTokenRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(style)(VendOAuthHandler));
